import React from "react";
import { ArrowRight, Info } from "lucide-react";
import SectionHeading from "./SectionHeading";

const PathCard = ({ p, t, onChoose }) => (
  <article
    data-testid={`coaching-path-${p.id}`}
    className="bb-card rounded-2xl p-6 md:p-7 flex flex-col"
  >
    <div className="flex items-center gap-3">
      <span className="w-10 h-10 rounded-xl bg-[#1E90FF] text-[#05070B] font-mono font-bold text-lg flex items-center justify-center">
        {p.badge}
      </span>
      <h3 className="text-lg md:text-xl font-bold text-[#F3F6FA] leading-snug">{p.title}</h3>
    </div>
    <p className="mt-4 text-sm text-[#A1A7B3] leading-relaxed">
      <span className="font-mono text-[10px] tracking-[0.2em] text-[#1E90FF] mr-2 uppercase">{t.ui.forWho}</span>
      {p.audience}
    </p>
    <ul className="mt-5 space-y-2.5 flex-1">
      {p.bullets.map((b) => (
        <li key={b} className="flex gap-2.5 text-sm text-[#C8CED8] leading-relaxed">
          <span className="mt-2 w-1.5 h-1.5 shrink-0 rounded-full bg-[#1E90FF]" />
          {b}
        </li>
      ))}
    </ul>
    <p className="mt-5 text-sm text-[#F3F6FA]/90 italic leading-relaxed border-l-2 border-[#1E90FF]/50 pl-3">
      {p.example}
    </p>
    <p className="mt-4 flex gap-2 text-xs text-[#A1A7B3] leading-relaxed">
      <Info size={14} className="shrink-0 mt-0.5 text-[#1E90FF]/70" /> {p.requirements}
    </p>
    <button
      type="button"
      onClick={onChoose}
      data-testid={`coaching-path-${p.id}-choose-btn`}
      className="group mt-6 h-11 w-full inline-flex items-center justify-center rounded-full border border-[#1E90FF]/40 text-[#F3F6FA] hover:bg-[#1E90FF] hover:border-[#1E90FF] text-sm font-semibold transition-colors"
    >
      {t.ui.choosePath}
      <ArrowRight size={16} className="ml-2 transition-transform group-hover:translate-x-1" />
    </button>
  </article>
);

const CoachingPaths = ({ t, onChoose }) => (
  <section id="paths" data-testid="coaching-paths" className="relative py-16 md:py-24 bg-[#070A12] scroll-mt-16">
    <div className="max-w-6xl mx-auto px-5 lg:px-10">
      <SectionHeading index="01" title={t.parcoursTitle} subtitle={t.parcoursSubtitle} />
      <div className="mt-10 md:mt-14 grid md:grid-cols-2 lg:grid-cols-3 gap-5 md:gap-6">
        {t.parcours.map((p, i) => (
          <PathCard key={p.id} p={p} t={t} onChoose={() => onChoose(i)} />
        ))}
      </div>
    </div>
  </section>
);

export default CoachingPaths;
